export const projectDetaillist = [
  {
    packageno: "001",
    packagename: "Solar Module",
    description: "High-efficiency ",
    category: "Electrical",
    subcategory: "Module Supply",
    boqqty: "1500",
    packagecreationdate: "03-01-2024",
    status: "Planning",
    department: "Procurement",
    duedate: "03-01-2024",
  },
  {
    packageno: "002",
    packagename: "Inverter Supply",
    description: "Grid-tied inverters",
    category: "Electrical",
    subcategory: "Inverter",
    boqqty: "30",
    packagecreationdate: "04-01-2024",
    status: "Ordered",
    department: "Procurement",
    duedate: "04-01-2024",
  },
  {
    packageno: "003",
    packagename: "Civil Works",
    description: "Construction",
    category: "Civil",
    subcategory: "Civil Works",
    boqqty: "200",
    packagecreationdate: "05-01-2024",
    status: "Delivered",
    department: "Procurement",
    duedate: "05-01-2024",
  },
  {
    packageno: "004",
    packagename: "Area Grading",
    description: "Land preparation",
    category: "Civil",
    subcategory: "Area",
    boqqty: "10000",
    packagecreationdate: "07-01-2024",
    status: "In Progress",
    department: "Procurement",
    duedate: "07-01-2024",
  },
  {
    packageno: "005",
    packagename: "Engineering ",
    description: "Feasibility studies",
    category: "Consultancy",
    subcategory: "Power Transform",
    boqqty: "5",
    packagecreationdate: "10-01-2024",
    status: "Completed",
    department: "Procurement",
    duedate: "10-01-2024",
  },
  {
    packageno: "006",
    packagename: "Erection Services",
    description: "Equipment ",
    category: "Mechanical",
    subcategory: "Soil Investigation",
    boqqty: "25",
    packagecreationdate: "12-01-2024",
    status: "Scheduled",
    department: "Procurement",
    duedate: "12-01-2024",
  },
  {
    packageno: "007",
    packagename: "Transformer ",
    description: "Power transform",
    category: "Electrical",
    subcategory: "BOS Electrical",
    boqqty: "10",
    packagecreationdate: "21-01-2024",
    status: "Awaiting",
    department: "Procurement",
    duedate: "21-01-2024",
  },
];
export const packagedetail = [
  {
    itemno: "1",
  },
  {
    itemno: "2",
  },
];

export const packagelisting = [
  {
    projectname: "Solar Array Sector",
    projectcode: "PV001",
    projectlocation: "Rajasthan, India",
    capacity: "50 MW",
    projectcreationdate: "15-01-2022",
    codasperppa: "01-12-2022",
    packagecode: "PKG1001",
    packagename: "Solar Panels",
    packagetype: "Material",
    packagecategory: "Solar",
    packagecreationdate: "20-01-2022",
    boq: "120",
    bom: "Yes",
    tenderdrawing: "No",
    technicalspecification: "Yes",
    rfqcode: "",
    rfqdate: "",
    rfqstatus: "Pending",
  },
  {
    projectname: "Wind Farm North",
    projectcode: "WF002",
    projectlocation: "Gujarat, India",
    capacity: "75 MW",
    projectcreationdate: "10-01-2022",
    codasperppa: "15-12-2022",
    packagecode: "PKG1002",
    packagename: "Turbine Blades",
    packagetype: "Component",
    packagecategory: "Wind",
    packagecreationdate: "20-02-2022",
    boq: "200",
    bom: "No",
    tenderdrawing: "Yes",
    technicalspecification: "Yes",
    rfqcode: "RFQ002",
    rfqdate: "28-02-2022",
    rfqstatus: "Approved",
  },
  {
    projectname: "Hydro Plant Delta",
    projectcode: "HY003",
    projectlocation: "Himachal Pradesh, India",
    capacity: "25 MW",
    projectcreationdate: "05-01-2022",
    codasperppa: "20-12-2022",
    packagecode: "PKG1003",
    packagename: "Control Systems",
    packagetype: "Equipment",
    packagecategory: "Hydro",
    packagecreationdate: "12-01-2022",
    boq: "80",
    bom: "Yes",
    tenderdrawing: "Yes",
    technicalspecification: "Yes",
    rfqcode: "RFQ003",
    rfqdate: "18-03-2022",
    rfqstatus: "Closed",
  },
  {
    projectname: "Geo Thermal East",
    projectcode: "GE004",
    projectlocation: "Maharashtra, India",
    capacity: "40 MW",
    projectcreationdate: "22-01-2022",
    codasperppa: "05-12-2022",
    packagecode: "PKG1004",
    packagename: "Piping Modules",
    packagetype: "Material",
    packagecategory: "Geothermal",
    packagecreationdate: "30-04-2022s",
    boq: "150",
    bom: "No",
    tenderdrawing: "No",
    technicalspecification: "No",
    rfqcode: "RFQ004",
    rfqdate: "05-05-2022",
    rfqstatus: "In Review",
  },
  {
    projectname: "Geo Thermal East",
    projectcode: "BM005",
    projectlocation: "Punjab, India",
    capacity: "60 MW",
    projectcreationdate: "18-01-2022",
    codasperppa: "10-12-2022",
    packagecode: "PKG1005",
    packagename: "Conveyor System",
    packagetype: "Material",
    packagecategory: "Biomass",
    packagecreationdate: "25-05-2022",
    boq: "95",
    bom: "Yes",
    tenderdrawing: "Yes",
    technicalspecification: "Yes",
    rfqcode: "RFQ005",
    rfqdate: "02-06-2022",
    rfqstatus: "Approved",
  },
  {
    projectname: "Tidal Wave Alpha",
    projectcode: "TW006",
    projectlocation: "Kerala, India",
    capacity: "35 MW",
    projectcreationdate: "09-01-2022",
    codasperppa: "15-12-2022",
    packagecode: "PKG1006",
    packagename: "Turbine Assembly",
    packagetype: "Equipment",
    packagecategory: "Tidal",
    packagecreationdate: "15-06-2022",
    boq: "110",
    bom: "No",
    tenderdrawing: "No",
    technicalspecification: "No",
    rfqcode: "RFQ006",
    rfqdate: "22-06-2022",
    rfqstatus: "Closed",
  },
  {
    projectname: "Energy Storage X",
    projectcode: "ES007",
    projectlocation: "Karnataka, India",
    capacity: "45 MW",
    projectcreationdate: "03-01-2022",
    codasperppa: "25-12-2022",
    packagecode: "PKG1007",
    packagename: "Battery Packs",
    packagetype: "Material",
    packagecategory: "Storage",
    packagecreationdate: "10-07-2022",
    boq: "130",
    bom: "Yes",
    tenderdrawing: "Yes",
    technicalspecification: "Yes",
    rfqcode: "",
    rfqdate: "",
    rfqstatus: "Pending",
  },
];

export const rfqlisting = [
  {
    rfqnumber: "RFQ-1001",
    projectname: "Solar Panel System",
    projectcode: "SP-45",
    packagecode: "PKG-101",
    packagename: "Solar PV Modules",
    description: "Photovoltaic Panels",
    qty: "500",
    noofvendorinvited: "3",
    noofvendorresponded: "1",
    noofvendorspendingresponse: "2",
    technicalevaluationstatus: "In Progress",
    commercialevaluationstatus: "Not Started",
    finalstatus: "Pending",
  },
  {
    rfqnumber: "RFQ-1002",
    link: "/admin/Buyer-Bidding-Commercial-Comparison",
    projectname: "Wind Turbine Array",
    projectcode: "WT-67",
    packagecode: "PKG-102",
    packagename: "Wind Generation Unit",
    description: "3MW Wind Turbines",
    qty: "15",
    noofvendorinvited: "4",
    noofvendorresponded: "7",
    noofvendorspendingresponse: "2",
    technicalevaluationstatus: "Completed",
    commercialevaluationstatus: "In Progress",
    finalstatus: "Pending",
  },
  {
    rfqnumber: "RFQ-1003",
    projectname: "Hydro Power Plant",
    projectcode: "HP-89",
    packagecode: "PKG-103",
    packagename: "Hydro Generators",
    description: "Hydroelectric Generators",
    qty: "10",
    noofvendorinvited: "3",
    noofvendorresponded: "9",
    noofvendorspendingresponse: "0",
    technicalevaluationstatus: "Completed",
    commercialevaluationstatus: "Completed",
    finalstatus: "Approved",
  },
  {
    rfqnumber: "RFQ-1004",
    projectname: "Biomass Facility",
    projectcode: "BM-12",
    packagecode: "PKG-104",
    packagename: "Biomass Processors",
    description: "Biomass Boilers",
    qty: "20",
    noofvendorinvited: "2",
    noofvendorresponded: "5",
    noofvendorspendingresponse: "3",
    technicalevaluationstatus: "Awaiting Results",
    commercialevaluationstatus: "Not Started",
    finalstatus: "In Review",
  },
  {
    rfqnumber: "RFQ-1005",
    projectname: "Solar Panel System",
    projectcode: "SP-45",
    packagecode: "PKG-101",
    packagename: "Solar PV Modules",
    description: "Photovoltaic Panels",
    qty: "500",
    noofvendorinvited: "3",
    noofvendorresponded: "1",
    noofvendorspendingresponse: "2",
    technicalevaluationstatus: "In Progress",
    commercialevaluationstatus: "Not Started",
    finalstatus: "Pending",
  },
];

export const rfqdetail = [
  {
    itemno: "1",
    uniysPlaceholder: "Solar Equipment",
    quantityPlaceholder: "1",
  },
  {
    itemno: "2",
    uniysPlaceholder: "Wind Turbines",
    quantityPlaceholder: "2",
  },
  {
    itemno: "3",
    uniysPlaceholder: "Hydroelectric ",
    quantityPlaceholder: "4",
  },
  {
    itemno: "4",
    uniysPlaceholder: "Construction Mat.",
    quantityPlaceholder: "1",
  },
];
export const detailrfqproject = [
  {
    vendorses: "PRIME LOGISTICS SERVICES",
    categoryy: "Exisitng",
    technicalevaluationstatus: "Pending",
    participationn: "Pending",
  },
  {
    vendorses: "ACME SUPPLIES CO.",
    categoryy: "Exisitng",
    technicalevaluationstatus: "Pending",
    participationn: "Done",
  },
  {
    vendorses: "STELLAR SERVICES LTD.",
    categoryy: "Exisitng",
    technicalevaluationstatus: "Pending",
    participationn: "Done",
  },
  {
    vendorses: "GLOBAL RESOURCES INC.",
    categoryy: "New",
    technicalevaluationstatus: "Pending",
    participationn: "Pending",
  },
  {
    vendorses: "SPRING ESSENTIALS	",
    categoryy: "New",
    technicalevaluationstatus: "Pending",
    participationn: "Pending",
  },
  {
    vendorses: "STELLAR SERVICES LTD.",
    categoryy: "New",
    technicalevaluationstatus: "Pending",
    participationn: "Pending",
  },
];

export const packagecreationform = [
  {
    itemno: "1",
  },
  {
    itemno: "2",
  },
];
export const rfqCreactionForm = [
  {
    itemno: "1",
    highefficiencymodulesPlaceholder: "High-efficiency modules",
    uommodulePlaceholder: "12",
    quentityPlaceholder: "1",
    raterupeesPlaceholder: "12,500",
    amountsPlaceholder: "12,500",
    quantityPlaceholder: "1",
  },
  {
    itemno: "2",
    highefficiencymodulesPlaceholder: "Grid-tied inverters",
    uommodulePlaceholder: "45",
    quentityPlaceholder: "2",
    raterupeesPlaceholder: "1400",
    amountsPlaceholder: "1400",
    quantityPlaceholder: "1",
  },
  {
    itemno: "3",
    highefficiencymodulesPlaceholder: "Construction",
    uommodulePlaceholder: "12",
    quentityPlaceholder: "3",
    raterupeesPlaceholder: "16000",
    amountsPlaceholder: "16000",
    quantityPlaceholder: "1",
  },
  {
    itemno: "4",
    highefficiencymodulesPlaceholder: "Land preparation",
    uommodulePlaceholder: "10",
    quentityPlaceholder: "5",
    raterupeesPlaceholder: "86000",
    amountsPlaceholder: "86000",
    quantityPlaceholder: "1",
  },
  {
    itemno: "5",
    highefficiencymodulesPlaceholder: "Feasibility studies",
    uommodulePlaceholder: "14",
    quentityPlaceholder: "2",
    raterupeesPlaceholder: "16000",
    amountsPlaceholder: "16000",
    quantityPlaceholder: "1",
  },
  {
    itemno: "6",
    highefficiencymodulesPlaceholder: "Equipment installation",
    uommodulePlaceholder: "22",
    quentityPlaceholder: "2",
    raterupeesPlaceholder: "36000",
    amountsPlaceholder: "36000",
    quantityPlaceholder: "1",
  },
  {
    itemno: "7",
    highefficiencymodulesPlaceholder: "Power transformers",
    uommodulePlaceholder: "12",
    quentityPlaceholder: "4",
    raterupeesPlaceholder: "34000",
    amountsPlaceholder: "34000",
    quantityPlaceholder: "1",
  },
  {
    itemno: "8",
    highefficiencymodulesPlaceholder: "",
    uommodulePlaceholder: "",
    quentityPlaceholder: "Total = (20)",
    raterupeesPlaceholder: "₹ 206,900",
    amountsPlaceholder: "₹ 206,900",
    quantityPlaceholder: "1",
  },
];
export const creactionformrfq = [
  {
    vendorcode: "V001",
    vendorname: "Power Solutions Inc.",
    category: "Electronics",
    vendortype: "Supplier",
  },
  {
    vendorcode: "V002",
    vendorname: "EcoTech Industries",
    category: "Green Energy",
    vendortype: "Manufacturer",
  },
  {
    vendorcode: "V003",
    vendorname: "SolarTech Solutions.",
    category: "Energy",
    vendortype: "Service Provider",
  },
  {
    vendorcode: "V004",
    vendorname: "Wind Energy Systems.",
    category: "Renewable",
    vendortype: "Manufacturer",
  },
  {
    vendorcode: "V005",
    vendorname: "EcoPower Innovations.",
    category: "Technology",
    vendortype: "Supplier",
  },
  {
    vendorcode: "V006",
    vendorname: "Sunlight Renewables.",
    category: "Solar",
    vendortype: "Manufacturer",
  },
  {
    vendorcode: "V007",
    vendorname: "IoEnergy Solutions.",
    category: "Biofuel",
    vendortype: "Supplier",
  },
];

export const dbResObj = {
  "success": true,
  "message": null,
  "data": {
      "onboardingCycleTime": {
          "minCycleTime": 133,
          "maxCycleTime": 133,
          "vendorCycleTimes": [
              {
                  "vendorId": "VEND00207",
                  "cycleTime": 133,
                  "onboardingStartDate": "2024-06-26T08:44:52.753Z",
                  "vendorActivationDate": "2024-11-06T07:55:30.369Z"
              }
          ],
          "averageCycleTime": 133,
          "monthlyData": [
              {
                  "month": 6,
                  "year": 2024,
                  "averageCycleTime": 133,
                  "minCycleTime": 133,
                  "maxCycleTime": 133
              }
          ],
          "kpi": "onboarding_cycle_time",
          "unit": "days"
      },
      "onboardingCompletionRate": {
          "kpi": "onboarding_completion_rate",
          "unit": "percentage",
          "completionRate": "9.12",
          "totalVendorsInvited": 351,
          "totalVendorsCompleted": 32,
          "monthlyData": [
              {
                  "totalVendorsInvited": 4,
                  "totalVendorsCompleted": 2,
                  "month": 2,
                  "year": 2024,
                  "completionRate": 50
              },
              {
                  "totalVendorsInvited": 25,
                  "totalVendorsCompleted": 2,
                  "month": 3,
                  "year": 2024,
                  "completionRate": 8
              },
              {
                  "totalVendorsInvited": 46,
                  "totalVendorsCompleted": 3,
                  "month": 4,
                  "year": 2024,
                  "completionRate": 6.52
              },
              {
                  "totalVendorsInvited": 49,
                  "totalVendorsCompleted": 3,
                  "month": 5,
                  "year": 2024,
                  "completionRate": 6.12
              },
              {
                  "totalVendorsInvited": 74,
                  "totalVendorsCompleted": 7,
                  "month": 6,
                  "year": 2024,
                  "completionRate": 9.46
              },
              {
                  "totalVendorsInvited": 62,
                  "totalVendorsCompleted": 3,
                  "month": 7,
                  "year": 2024,
                  "completionRate": 4.84
              },
              {
                  "totalVendorsInvited": 20,
                  "totalVendorsCompleted": 4,
                  "month": 8,
                  "year": 2024,
                  "completionRate": 20
              },
              {
                  "totalVendorsInvited": 32,
                  "totalVendorsCompleted": 2,
                  "month": 9,
                  "year": 2024,
                  "completionRate": 6.25
              },
              {
                  "totalVendorsInvited": 37,
                  "totalVendorsCompleted": 6,
                  "month": 10,
                  "year": 2024,
                  "completionRate": 16.22
              },
              {
                  "totalVendorsInvited": 2,
                  "totalVendorsCompleted": 0,
                  "month": 11,
                  "year": 2024,
                  "completionRate": 0
              }
          ]
      },
      "documentSubmissionTime": {
          "kpi": "time_to_submit_documents",
          "unit": "days",
          "minSubmissionTime": 0,
          "maxSubmissionTime": 133,
          "vendorSubmissionTimes": [
              {
                  "vendorId": "VEND00207",
                  "submissionTime": 133,
                  "onboardingStartDate": "2024-06-26T08:44:52.753Z",
                  "formSubmissionDate": "2024-11-06T07:49:38.976Z"
              },
              {
                  "vendorId": "VEND00384",
                  "submissionTime": 1,
                  "onboardingStartDate": "2024-11-07T07:32:43.644Z",
                  "formSubmissionDate": "2024-11-08T10:12:24.581Z"
              },
              {
                  "vendorId": "VEND00385",
                  "submissionTime": 0,
                  "onboardingStartDate": "2024-11-11T05:48:40.087Z",
                  "formSubmissionDate": "2024-11-11T05:51:29.069Z"
              }
          ],
          "averageSubmissionTime": 44.67,
          "monthlyData": [
              {
                  "month": 6,
                  "year": 2024,
                  "averageSubmissionTime": 133,
                  "minSubmissionTime": 133,
                  "maxSubmissionTime": 133
              },
              {
                  "month": 11,
                  "year": 2024,
                  "averageSubmissionTime": 0.5,
                  "minSubmissionTime": 0,
                  "maxSubmissionTime": 1
              }
          ]
      },
      "internalApprovalTime": {
          "kpi": "internal_approval_time",
          "unit": "days",
          "minApprovalTime": 0,
          "maxApprovalTime": 0,
          "vendorApprovalTimes": [
              {
                  "vendorId": "VEND00207",
                  "approvalTime": 0,
                  "formSubmissionDate": "2024-11-06T07:49:38.976Z",
                  "vendorActivationDate": "2024-11-06T07:55:30.369Z"
              }
          ],
          "averageApprovalTime": 0,
          "monthlyData": [
              {
                  "minApprovalTime": 0,
                  "maxApprovalTime": 0,
                  "month": 6,
                  "year": 2024,
                  "averageApprovalTime": 0
              }
          ]
      },
      "vendorDropOffRate": {
          "kpi": "vendor_drop_off_rate",
          "unit": "percentage",
          "dropOffRate": "0.49",
          "vendorsStarted": 206,
          "vendorsCompleted": 205,
          "monthlyData": [
              {
                  "vendorsStarted": 2,
                  "vendorsCompleted": 2,
                  "dropOffRate": 0,
                  "month": 2,
                  "year": 2024
              },
              {
                  "vendorsStarted": 6,
                  "vendorsCompleted": 6,
                  "dropOffRate": 0,
                  "month": 3,
                  "year": 2024
              },
              {
                  "vendorsStarted": 22,
                  "vendorsCompleted": 22,
                  "dropOffRate": 0,
                  "month": 4,
                  "year": 2024
              },
              {
                  "vendorsStarted": 24,
                  "vendorsCompleted": 24,
                  "dropOffRate": 0,
                  "month": 5,
                  "year": 2024
              },
              {
                  "vendorsStarted": 54,
                  "vendorsCompleted": 54,
                  "dropOffRate": 0,
                  "month": 6,
                  "year": 2024
              },
              {
                  "vendorsStarted": 44,
                  "vendorsCompleted": 44,
                  "dropOffRate": 0,
                  "month": 7,
                  "year": 2024
              },
              {
                  "vendorsStarted": 6,
                  "vendorsCompleted": 6,
                  "dropOffRate": 0,
                  "month": 8,
                  "year": 2024
              },
              {
                  "vendorsStarted": 19,
                  "vendorsCompleted": 19,
                  "dropOffRate": 0,
                  "month": 9,
                  "year": 2024
              },
              {
                  "vendorsStarted": 27,
                  "vendorsCompleted": 27,
                  "dropOffRate": 0,
                  "month": 10,
                  "year": 2024
              },
              {
                  "vendorsStarted": 2,
                  "vendorsCompleted": 1,
                  "dropOffRate": 50,
                  "month": 11,
                  "year": 2024
              }
          ]
      }
  }
};
